import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/totalVisitsSagas";
import PropTypes from "prop-types";

import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import LearnMore from "../../../../components/learnMore/learnMore";
import CustomDateRanges from "./smartComponents/customDateRanges";
import PeriodType from "./smartComponents/periodType";
import DatePicker from "./smartComponents/datePicker";
import "../attendance_common.css.scss";

const TotalVisitsModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    filtersDirty,
    startDate,
    endDate,
    currentUser: { clientName = "" }
  } = useSelector((state) => state.totalVisits);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="select-box-no-width"></div>

            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Type</p>
                <PeriodType />
              </div>

              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box select-box-no-width multi">
                <p>Date</p>
                <DatePicker />
              </div>
              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>
          </div>
        </div>
        <div className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <TableOrStackedBarChart />
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Total Visits"
        isLoading={isLoading}
        content={content()}
        learnMore={<LearnMore {...learnMoreProps(clientName)} />}
      />
    </div>
  );
};

let learnMoreProps = (clientName) => {
  clientName = clientName.toLowerCase();
  return {
    title: "Total Visits Chart",
    customStyles: { width: "500px" },
    content: (
      <p>
        {`The Total Visits chart shows you how many times your ${clientName} came to your business in the last week/month/day. The chart will separate out arrivals,
        appointment visits, and class visits.`}
      </p>
    )
  };
};

export default React.memo(TotalVisitsModule);

TotalVisitsModule.propTypes = {
  params: PropTypes.object,
  clientName: PropTypes.string,
  isLoading: PropTypes.bool,
  filtersDirty: PropTypes.bool,
  updatesLoading: PropTypes.bool,
  updateChart: PropTypes.func,
  resetFilters: PropTypes.func,
  compareDates: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};
